import { Form } from 'antd-mobile';
import React from 'react';
const ValueDescription = (props) => {
    const { layout = 'horizontal', label, value, colon = true, extra, labelStyle, valueStyle, style, } = props;
    return (React.createElement("div", { style: {
            fontSize: '13px',
            display: 'flex',
            flexDirection: layout === 'vertical' ? 'column' : 'row',
            ...style,
        } },
        React.createElement("span", { style: { flexShrink: 0, width: '80px', color: '#999999', ...labelStyle } },
            label,
            React.createElement("span", null, colon && '：')),
        React.createElement("span", { style: { flexGrow: 1, ...valueStyle } }, value),
        React.createElement("span", null, extra)));
};
const Description = (props) => {
    const { name, ...rest } = props;
    return (React.createElement(Form.Item, { noStyle: true, name: name },
        React.createElement(ValueDescription, Object.assign({}, rest))));
};
export default Description;
